export const Logout = () => {
    localStorage.removeItem('reestr-expiret');
    localStorage.removeItem('reestr-token');
    window.location.reload('/');
}